import { BaseEvent } from '~/app/tracking/events/base-event';
import * as feldm from '~/app/tracking/feld-m-types';
import { EventAction } from '~/app/tracking/feld-m-types';

export type IncentiveEventParams = {
	eventName: string;
	relatedIncentive?: feldm.ProductDataConfiguredVehicle['incentives'];
	componentName: string;
	label?: string;
	elementName: string;
	clickID?: string;
};

export class IncentivesClickEvent extends BaseEvent {
	constructor({ eventName, relatedIncentive, componentName, label, elementName, clickID }: IncentiveEventParams) {
		super({
			eventInfo: {
				eventAction: EventAction.Content,
				eventName,
			},

			attributes: {
				componentName,
				elementName,
				relatedIncentive,
				label: label || '',
				clickID: clickID || '',
			},
		});
	}
}
